import { useMutation } from 'react-query';

import { root_path } from '@routes';
import { FreeProTrialParams, freeProTrial } from '@utils/backend-api/subscribe';

const useFreeProTrial = () => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: FreeProTrialParams) => freeProTrial(params),
    {
      onSuccess: () => {
        const anchor = document.createElement('a');
        anchor.href = root_path();
        anchor.click();
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
};

export default useFreeProTrial;
